module.exports = __webpack_public_path__ + "img/6.feb0d40d.jpg";